// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentSessionsController = function ($scope, $routeParams, PaymentSessions) {
    $scope.filter = {
        search: $routeParams.search,
        before: "",
        after: "" };

    $scope.loadSessions = function () {
        $scope.sessions = $scope.paginator(function (options, callback) {
                return PaymentSessions.query(options, function () { callback(); });
            },
            {
                searchFilter: $scope.filter.search,
                before: $scope.filter.before,
                after: $scope.filter.after
            },
            100);
    };

    // Details (the PSP requests logged against the reserved transaction id, the session creation among them) are
    // loaded on first expand only.
    $scope.toggleDetails = function (session) {
        session.showDetails = !session.showDetails;
        if (session.showDetails && !session.details)
            session.details = PaymentSessions.get({ sessionId: session.Id });
    };

    $scope.onResetFilterClick = function () {
        $scope.filter.search = null;
        $scope.filter.before = "";
        $scope.filter.after = "";
        $scope.loadSessions();
    };

    $scope.loadSessions();
};
PaymentSessionsController.$inject = ['$scope', '$routeParams', 'PaymentSessions'];
